var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39657 3.5C4.93366 3.5 4.55839 3.8749 4.55839 4.33737C4.55839 4.79983 4.93365 5.17473 5.39657 5.17473L9.64706 5.17473L3.7455 11.0705C3.41817 11.3975 3.41817 11.9277 3.7455 12.2547C4.07283 12.5818 4.60354 12.5818 4.93087 12.2547L10.9096 6.28183V10.6226C10.9096 11.0614 11.2656 11.417 11.7048 11.417C12.145 11.417 12.5015 11.0597 12.5 10.6199L12.4759 3.5H5.39657Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrow);
export default __webpack_public_path__ + "static/media/link-arrow.533b5153313ba885a2eec4d9e9b673b8.svg";
export { ForwardRef as ReactComponent };